import ToolTipBaiDu from "@/plugin/gis-viewer/widgets/Overlays/bd/ToolTipBaiDu";
import { IFindParameter, IOverlayDelete, IOverlayParameter, IPicChangeParameter, IPointGeometry, IPointSymbol, IResult } from "@/types/map";
// import ToolTip2D from "@/plugin/gis-viewer/widgets/Overlays/arcgis/ToolTip2D";
declare let BMap: any;
declare let BMapLib: any;

export class PointCollection {
  private static intances: Map<string, any>;

  private view!: any;
  private overlays = new Array();
  private markerClustererLayer = new Array();
  private animationPoint: any;
  private animationHandler: any;
  private showGisDeviceInfo: any;

  private tooltip: any;
  private popupTypes: Map<string, any> = new Map<string, any>();
  private tooltipTypes: Map<string, any> = new Map<string, any>();

  private popupOfTypes: Map<string, any> = new Map<string, any>();
  private tooltipOfTypes: Map<string, any> = new Map<string, any>();

  private popup: any;
  private glImageData: Map<string, any> = new Map<string, any>();

  private constructor(view: any) {
    this.view = view;
  }

  public static getInstance(view: any) {
    let id = view.getContainer().id;
    if (!PointCollection.intances) {
      PointCollection.intances = new Map();
    }
    let intance = PointCollection.intances.get(id);
    if (!intance) {
      intance = new PointCollection(view);
      PointCollection.intances.set(id, intance);
    }
    return intance;
  }
  public static destroy() {
    (PointCollection.intances as any) = null;
  }
  private async loadImageAsync(url: string) {
    let _this = this;
    let url_size = url.substr(0, 50);
    return new Promise((resolve, reject) => {
      let cimage = _this.glImageData.get(url_size);
      if (cimage) {
        resolve(cimage);
      } else {
        const image = new Image();
        image.src = url;
        image.onload = function () {
          _this.glImageData.set(url_size, image);
          resolve(image);
        };
        image.onerror = function () {
          reject(0);
        };
      }
    });
  }
  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    const defaultSymbol = params.defaultSymbol as IPointSymbol;
    const defaultType = params.type || params.overlays[0].type;
    if (!defaultType) {
      return {
        status: 0,
        message: "type is required！",
      };
    }
    const defaultButtons = params.defaultButtons;
    const centerResult = params.centerResult !== false;
    const defaultZoom = params.defaultZoom || 14;
    //默认弹窗样式
    const defaultInfoTemplate = params.defaultInfoTemplate;
    //自定义vue弹窗样式
    /************auto/move/show-popup/tooltip*****************/
    const showPopup = params.showPopup;
    const showTooltip = params.showTooltip;
    const moveTooltip = params.moveTooltip;
    const movePopup = params.movePopup;
    const autoPopup = params.autoPopup;
    const autoTooltip = params.autoTooltip;

    const tooltipComponent = params.tooltipComponent;
    const popupComponent = params.popupComponent;

    this.popupOfTypes.set(defaultType, popupComponent);
    this.tooltipOfTypes.set(defaultType, tooltipComponent);

    const popupAndTooltip = {
      showPopup,
      showTooltip,
      moveTooltip,
      movePopup,
      autoPopup,
      autoTooltip,
    };

    const componentsObj = {
      tooltipComponent,
      popupComponent,
    };

    let addCount = 0;
    let overlays: any[] = [];
    let pointCollection: any;

    let size: any = new BMap.Size(20, 20);
    if (defaultSymbol && defaultSymbol.size) {
      size = new BMap.Size(defaultSymbol.size instanceof Array ? defaultSymbol.size[0] : defaultSymbol.size, defaultSymbol.size instanceof Array ? defaultSymbol.size[1] : defaultSymbol.size);
    }
    if (defaultSymbol && defaultSymbol.width) {
      size = new BMap.Size(defaultSymbol.width, defaultSymbol.height);
    }

    for (let i = 0; i < params.overlays.length; i++) {
      const overlay = params.overlays[i];

      const fields = overlay.fields || {};
      const buttons = overlay.buttons || defaultButtons;
      let graphic = new BMap.Point((overlay.geometry as IPointGeometry).x, (overlay.geometry as IPointGeometry).y);
      if (!graphic) {
        return {
          message: "请检查overlay输入是否正确!",
          status: 0,
        };
      }
      graphic.attributes = fields;
      graphic.buttons = buttons;
      graphic.attributes.tooltip = tooltipComponent;
      graphic.attributes.popup = popupComponent;
      graphic.attributes.showPopup = showPopup;
      graphic.attributes.showTooltip = showTooltip;
      graphic.id = overlay.id;
      graphic.type = overlay.type || defaultType;
      graphic.geometry = overlay.geometry;
      graphic.icon = {
        icon: new BMap.Icon(defaultSymbol.url, size, {
          imageSize: size,
        }),
      };
      if (overlay.symbol) {
        graphic.ownImage = await this.loadImageAsync((overlay.symbol as any).url);
      }
      overlays.push(graphic);
      this.overlays.push(graphic);
      addCount++;
    }

    let img = await this.loadImage(defaultSymbol.url || "");
    pointCollection = new BMap.PointCollection(overlays, {
      size: size,
      shape: 3,
      image: img,
    });
    let _this = this;

    pointCollection.type = defaultType;
    let title: string;
    let content: string;

    pointCollection.addEventListener("click", async (e: any) => {
      if (pointCollection._visible) {
        if (defaultInfoTemplate) {
          title = defaultInfoTemplate.title || "";
          content = defaultInfoTemplate.content;
          let popupcontent = this.getPopUpHtml(e.point, content);
          let infoWindow = new BMap.InfoWindow(popupcontent, {
            width: 0, // 信息窗口宽度
            height: 0, // 信息窗口高度
            title: title, // 信息窗口标题
            enableMessage: true, //设置允许信息窗发送短息
            message: "",
          }); // 创建信息窗口对象
          e.target.isOpenInfo = true;
          _this.view.openInfoWindow(infoWindow, e.point);
        }
        _this.showGisDeviceInfo(
          e.point.type,
          e.point.id,
          { attributes: e.point.attributes },
          {
            lng: e.point.lng,
            lat: e.point.lat,
          }
        );
      }
    });
    this.view.addOverlay(pointCollection);
    //处理弹窗逻辑,弹窗优先级popup->tooltip,动作优先级show->move->auto
    //冲突关系：同类冲突，例如autpPopup和movePopup冲突，autoTooltip和moveTooltip冲突
    //示意：假如同时存在autoPopup和showPopup为true，认为两者冲突，则autoPopup为false
    if (!defaultInfoTemplate) {
      await this.processPopupAndTooltip(pointCollection, popupAndTooltip, componentsObj);
    }
    if (centerResult) {
      let viewpoint = this.view.getViewport(overlays);
      await this.view.centerAndZoom(viewpoint.center, viewpoint.zoom);
    }

    return {
      status: 0,
      message: "ok",
      result: `成功添加${params.overlays.length}中的${addCount}个覆盖物`,
    };
  }
  private getPopUpHtml(graphic: any, content: string): any {
    let tipContent = content;
    for (let fieldName in graphic.attributes) {
      if (graphic.attributes.hasOwnProperty(fieldName)) {
        tipContent = tipContent.replace(new RegExp("{" + fieldName + "}", "g"), graphic.attributes[fieldName]);
      }
    }
    return tipContent;
  }
  public async changePcPicById(params: IPicChangeParameter): Promise<IResult> {
    const id = params.id;
    const curPicUrl = params.pictureUrl;
    const callback = params.callback || false;
    const isSelected = params.isSelected || false;

    let callbackResults: any[] = [];
    let overlays: any[] = [];
    let layers = this.view.getOverlays();
    for (let i = 0; i < layers.length; i++) {
      let layer = layers[i];
      if (layer instanceof BMap.PointCollection) {
        overlays = layer._data.points;
      }
      let num = 0;
      for (let overlay of overlays) {
        if (id == overlay.id) {
          overlay.changeImage = await this.loadImage(curPicUrl);
          overlay.isSelected = isSelected;
          overlay.attributes.isSelected = isSelected;
          let pt = overlays.splice(num, 1);
          overlays.push(pt[0]);
          layer.draw();
          if (callback) {
            callbackResults.push(overlay);
          }
        }
        num++;
      }
    }

    return {
      message: "成功调用该方法",
      status: 0,
      result: callback ? JSON.stringify(callbackResults) : "获取该点位信息请在方法中加入callback属性",
    };
  }
  private loadImage(src: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.src = src;
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        resolve(img);
      };
    });
  }
  public async findPointCollection(params: IFindParameter): Promise<IResult> {
    let type = params.layerName;
    let ids = params.ids || [];
    let level = params.level || this.view.getZoom();
    let overlays: any[] = [];
    let centerResult = params.centerResult;
    const animation = params.animation !== false;
    const callback = params.callback || true;
    const callbackResults = [];
    let _this = this;
    let layers = this.view.getOverlays();
    for (let i = 0; i < layers.length; i++) {
      let layer = layers[i];
      if (layer instanceof BMap.PointCollection && type == layer.type) {
        let points = layer._data.points;
        overlays = overlays.concat(points);
      }
    }
    let result;
    for (let overlay of overlays) {
      if (type == overlay.type && ids.indexOf(overlay.id) >= 0) {
        if (centerResult) {
          let center = new BMap.Point(overlay.lng, overlay.lat);
          if (center.lat !== null && center.lng !== null) {
            await _this.view.centerAndZoom(center, level);
            if (animation) {
              await this.overlayAnimation(overlay);
            }
            break;
          }
        }
        if (callback) {
          callbackResults.push(overlay);
        }
      }
    }

    return {
      message: "成功调用该方法",
      status: 0,
      result: JSON.stringify(callbackResults),
    };
  }
  public async overlayAnimation(overlay: any) {
    if (this.animationPoint) {
      this.view.removeOverlay(this.animationPoint);
      if (this.animationHandler) {
        clearTimeout(this.animationHandler);
      }
    }
    this.animationPoint = new BMap.Marker(overlay); // 创建标注
    this.view.addOverlay(this.animationPoint); // 将标注添加到地图中
    this.animationPoint.setAnimation(2); //跳动的动画
    this.animationHandler = setTimeout(() => {
      this.view.removeOverlay(this.animationPoint);
      this.animationPoint = undefined;
      this.animationHandler = undefined;
    }, 3000);
  }
  public async deletePointCollection(params: IOverlayDelete): Promise<IResult> {
    let delCount = 0;
    let layers = this.view.getOverlays();
    let types = params ? params.types || [] : [];
    if (layers.length > 0) {
      for (let i = 0; i < layers.length; i++) {
        let layer = layers[i];
        if (types.indexOf(layer.type) > -1 || params == undefined) {
          if (layer instanceof BMap.PointCollection) {
            this.view.removeOverlay(layer);
            delCount++;
          }
        }
      }
    }
    return {
      status: 0,
      message: "成功调用该方法！",
      result: delCount ? `成功删除${delCount}个覆盖物！` : `未删除任何覆盖物！`,
    };
  }

  private async listenOverlayClick(popupType: string, popup: Vue.Component, layer: any): Promise<IResult> {
    if (!popupType) {
      return {
        status: 0,
        message: "error!please input type of popup/tooltip",
      };
    }
    if (!popup) {
      return {
        status: 0,
        message: "error!please input vue popup/tooltip component",
      };
    }

    switch (popupType) {
      case "showPopup":
        layer.addEventListener("click", async (e: any) => {
          if (layer._visible) {
            let fields = e.point.attributes;
            let content = null;
            if (!fields) {
              return;
            }
            content = fields.popupWindow;
            if (!content) {
              return;
            }
            let center = new BMap.Point(e.point.lng, e.point.lat);

            if (this.popup) {
              this.popup.remove();
              this.popup = null;
            }
            if (content.hasOwnProperty("valuePromise")) {
              content.valuePromise = await content.valuePromise;
            }
            this.popup = new ToolTipBaiDu(this.view, popup, content, center, fields);

            this.showGisDeviceInfo(
              e.point.id,
              e.point.type,
              { attributes: e.point.attributes },
              {
                lng: e.point.lng,
                lat: e.point.lat,
              }
            );
          }
        });
        break;
      case "showTooltip":
        layer.addEventListener("click", async (e: any) => {
          let fields = e.point.attributes;
          let content = null;
          if (!fields) {
            return;
          }
          content = fields.tooltipWindow;
          if (!content) {
            return;
          }
          let center = e.target.getPosition();

          if (this.tooltip) {
            this.tooltip.remove();
            this.tooltip = null;
          }
          if (content.hasOwnProperty("valuePromise")) {
            content.valuePromise = await content.valuePromise;
          }
          this.tooltip = new ToolTipBaiDu(this.view, popup, content, center);
        });
        break;
      default:
        break;
    }

    return {
      status: 0,
      message: "成功调用该方法！",
    };
  }
  private async listenOverlayMouseOver(popupType: string, popup: Vue.Component, layer: any): Promise<any> {
    if (!popupType) {
      return {
        status: 0,
        message: "error!please input type of popup/tooltip",
      };
    }
    if (!popup) {
      return {
        status: 0,
        message: "error!please input vue popup/tooltip component",
      };
    }

    switch (popupType) {
      case "movePopup":
        layer.addEventListener("mouseover", async (e: any) => {
          let fields = e.target.attributes;
          let content = null;
          if (!fields) {
            return;
          }
          content = fields.popupWindow;
          if (!content) {
            return;
          }
          let center = e.target.getPosition();

          if (this.popup) {
            this.popup.remove();
            this.popup = null;
          }
          if (content.hasOwnProperty("valuePromise")) {
            content.valuePromise = await content.valuePromise;
          }
          this.popup = new ToolTipBaiDu(this.view, popup, content, center);
        });

        layer.addEventListener("mouseout", async (e: any) => {
          if (this.popup) {
            this.popup.remove();
            this.popup = null;
          }
        });

        break;
      case "moveTooltip":
        layer.addEventListener("mouseover", async (e: any) => {
          let fields = e.target.attributes;
          let content = null;
          if (!fields) {
            return;
          }
          content = fields.tooltipWindow;
          let center = e.target.getPosition();

          if (this.tooltip) {
            this.tooltip.remove();
            this.tooltip = null;
          }
          if (content.hasOwnProperty("valuePromise")) {
            content.valuePromise = await content.valuePromise;
          }
          this.tooltip = new ToolTipBaiDu(this.view, popup, content, center);
        });

        layer.addEventListener("mouseout", async (e: any) => {
          if (this.tooltip) {
            this.tooltip.remove();
            this.tooltip = null;
          }
        });

        break;
      default:
        break;
    }
  }
  public async showPopup(params: IOverlayDelete): Promise<IResult> {
    if (this.popup) {
      await this.closePopup();
    }
    const types = params.types || [];
    const ids = params.ids || [];
    let overlays: any = this.view.getOverlays();

    for (let overlay of overlays) {
      if (
        //只判断type
        (types.length > 0 && ids.length === 0 && types.indexOf(overlay.type) >= 0) ||
        //只判断id
        (types.length === 0 && ids.length > 0 && ids.indexOf(overlay.id) >= 0) ||
        //type和id都要判断
        (types.length > 0 && ids.length > 0 && types.indexOf(overlay.type) >= 0 && ids.indexOf(overlay.id) >= 0)
      ) {
        let fields = overlay.attributes;
        if (!fields) {
          continue;
        }
        let content: any = fields.popupWindow;

        let popupComponent: any = fields.popup;
        if (!content || !popupComponent) {
          continue;
        }
        let center = overlay.getPosition();

        if (this.popup) {
          this.popup.remove();
          this.popup = null;
        }
        if (content.hasOwnProperty("valuePromise")) {
          await content.valuePromise;
        }
        const popup = new ToolTipBaiDu(this.view, popupComponent, content, center);
        popup.id = overlay.id;
        popup.type = overlay.type;

        this.popup = popup;
      }
    }

    return {
      status: 0,
      message: "ok",
      result: "成功调用方法，但无法保证可以正确显示弹窗",
    };
  }
  public async closePopup(): Promise<IResult> {
    let close = false;
    if (this.tooltip) {
      this.tooltip.remove();
      this.tooltip = null;
      close = true;
    }

    if (this.popup) {
      this.popup.remove();
      this.popup = null;
      close = true;
    }

    return {
      status: 0,
      message: "ok",
      result: close ? "成功关闭VUE弹窗" : "未存在VUE弹窗",
    };
  }
  private async autoTooltip(tooltip: Vue.Component, type?: string) {
    if (!this.overlays.length) {
      return {
        status: 0,
        message: "there is no overlays,add first!",
      };
    }

    let tooltipCount = 0;
    let tooltips: ToolTipBaiDu[] = [];

    if (type && typeof type === "string") {
      //有type情况
      let tooltipOfType: ToolTipBaiDu[] = this.tooltipTypes.get(type); //首先检查该图层是否已经显示Popup
      if (tooltipOfType) {
        this.tooltipTypes.delete(type); //如果存在改类型的弹窗，则遍历数组，删除所有改类弹窗
        for (let popup of tooltipOfType) {
          popup.remove();
        }
      }

      for (const overlay of this.overlays) {
        if (overlay.type !== type) {
          continue;
        }

        let content = overlay.attributes.tooltipWindow;
        if (!content) {
          continue;
        }

        let center = overlay.getPosition();
        if (content.hasOwnProperty("valuePromise")) {
          content.valuePromise = await content.valuePromise;
        }

        let _popup = new ToolTipBaiDu(this.view, tooltip, content, center);
        tooltips.push(_popup);
        tooltipCount++;
      }
      this.popupTypes.set(type, tooltips);

      return {
        status: 0,
        message: `finish autoPopup`,
        result: `the layer of ${type} with ${tooltipCount}popups!`,
      };
    } else {
      for (const overlay of this.overlays) {
        let content = overlay.attributes.popupWindow;
        if (!content) {
          continue;
        }

        let center = overlay.getPosition();
        if (content.hasOwnProperty("valuePromise")) {
          content.valuePromise = await content.valuePromise;
        }
        let _tooltip = new ToolTipBaiDu(this.view, tooltip, content, center);
        tooltips.push(_tooltip);
        tooltipCount++;
      }

      return {
        status: 0,
        message: `finish autoPopup`,
        result: `add the number of${tooltipCount}popups!`,
      };
    }
  }
  private async processPopupAndTooltip(layer: any, popAndTip: any, componentsObj: any) {
    let showPopup = popAndTip.showPopup;
    let showTooltip = popAndTip.showTooltip;
    let moveTooltip = popAndTip.moveTooltip;
    let movePopup = popAndTip.movePopup;
    let autoPopup = popAndTip.autoPopup;
    let autoTooltip = popAndTip.autoTooltip;

    const tooltipComponent = componentsObj.tooltipComponent;
    const popupComponent = componentsObj.popupComponent;

    if (showPopup) {
      autoPopup = false;
      movePopup = false;
    } else if (movePopup) {
      autoPopup = false;
    } else {
      if (autoPopup) {
        console.log("autoPopup");
      }
    }

    if (showTooltip) {
      autoTooltip = false;
      moveTooltip = false;
    } else if (moveTooltip) {
      autoTooltip = false;
    } else {
      if (autoTooltip) {
        console.log("autoTooltip");
      }
    }

    if (showPopup && popupComponent) {
      await this.listenOverlayClick("showPopup", popupComponent, layer);
    } else if (movePopup && popupComponent) {
      await this.listenOverlayMouseOver("movePopup", popupComponent, layer);
    } else if (autoPopup && popupComponent) {
      await this.autoPopup(popupComponent);
    } else {
      console.log("no overlays popup");
    }

    if (showTooltip && tooltipComponent) {
      await this.listenOverlayClick("showTooltip", tooltipComponent, layer);
    } else if (moveTooltip && tooltipComponent) {
      await this.listenOverlayMouseOver("moveTooltip", tooltipComponent, layer);
    } else if (autoTooltip && tooltipComponent) {
      await this.autoTooltip(tooltipComponent);
    }
  }

  // public async getDistance(params: IPointDistanceParameter): Promise<IResult> {
  //   const startPoint = params.startPoint;
  //   const endPoint = params.endPoint;

  //   let point1 = new BMap.Point(startPoint[0], startPoint[1]);
  //   let point2 = new BMap.Point(endPoint[0], endPoint[1]);
  //   let distance = this.view.getDistance(point1, point2);
  //   return {
  //     message: "成功调用该方法",
  //     status: 0,
  //     result: {distance: distance}
  //   };
  // }
  //废弃
  private async autoPopup(popup: Vue.Component, type?: string): Promise<IResult> {
    if (!this.overlays.length) {
      return {
        status: 0,
        message: "there is no overlays,add first!",
      };
    }

    let popupCount = 0;
    let popups: ToolTipBaiDu[] = [];

    if (type && typeof type === "string") {
      //有type情况
      let popupOfType: ToolTipBaiDu[] = this.popupTypes.get(type); //首先检查该图层是否已经显示Popup
      if (popupOfType) {
        this.popupTypes.delete(type); //如果存在改类型的弹窗，则遍历数组，删除所有改类弹窗
        for (let popup of popupOfType) {
          popup.remove();
        }
      }

      for (const overlay of this.overlays) {
        if (overlay.type !== type) {
          continue;
        }

        let content = overlay.attributes.popupWindow;
        if (!content) {
          continue;
        }

        let center = overlay.getPosition();
        if (content.hasOwnProperty("valuePromise")) {
          content.valuePromise = await content.valuePromise;
        }

        let _popup = new ToolTipBaiDu(this.view, popup, content, center);
        popups.push(_popup);
        popupCount++;
      }
      this.popupTypes.set(type, popups);

      return {
        status: 0,
        message: `finish autoPopup`,
        result: `the layer of ${type} with ${popupCount}popups!`,
      };
    } else {
      for (const overlay of this.overlays) {
        let content = overlay.attributes.popupWindow;
        if (!content) {
          continue;
        }

        let center = overlay.getPosition();
        if (content.hasOwnProperty("valuePromise")) {
          content.valuePromise = await content.valuePromise;
        }
        let _popup = new ToolTipBaiDu(this.view, popup, content, center);
        popups.push(_popup);
        popupCount++;
      }

      return {
        status: 0,
        message: `finish autoPopup`,
        result: `add the number of${popupCount}popups!`,
      };
    }
  }
}
